import React from 'react';
import { Grid, CssBaseline, CircularProgress } from '@material-ui/core';
import useStyles from './styles';

const LoadingDealer: React.FC = () => {
  const classes = useStyles();
  return (
    <>
      <CssBaseline />
      <Grid className={classes.root}>
        <CircularProgress className={classes.loading}></CircularProgress>
      </Grid>
    </>
  );
};

export default LoadingDealer;
